import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { backendApi } from "../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import $ from "jquery";
import noData from "../../images/noData.png";
import { format, addDays } from "date-fns";
import Select from "react-select";
import { FaMapPin, FaRupeeSign, FaShoppingBag, FaAward } from "react-icons/fa";
import { MdOutlineDescription } from "react-icons/md";
import { BsCalendar2Date } from "react-icons/bs";
import { FcHighPriority } from "react-icons/fc";
import { useSelector } from "../../components/hooks/hooks.js";

export default function CreateBlackList() {
  const { userDetails, userData, userId, siteId } = useSelector(
    (state) => state.login
  );
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [jobTypes, setJobTypes] = useState([]);
  const [statusTypes, setStatusTypes] = useState([]);
  const [priorityTypes, setPriorityTypes] = useState([]);
  const [status, setStatus] = useState("Open");
  const [priority, setPriority] = useState("High");
  const [jobType, setJobType] = useState("Full Time");
  const [summary, setSummary] = useState("");
  const [description, setDescription] = useState("");
  const [positionsOpen, setPositionsOpen] = useState("");
  const [experience, setExperience] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState();
  const [salary, setSalary] = useState("");
  const [location, setLocation] = useState("");
  const [openings, setOpenings] = useState([]);
  const [recruitersList, setRecruitersList] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [userList, setUserList] = useState([]);
  const [users, setUsers] = useState([]);
  const [jobSkills, setJobSkills] = useState([]);
  const [jobTab, setJobTab] = useState(true);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [skillId, setSkillId] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("NewVacancyMenu").classList.add("active");
    }, 500);
    openingInit();
    openingHistory();
    getUserList();
  }, []);

  // const workExperienceOptions = [
  //   { value: "0-1", label: "0-1 Years" },
  //   { value: "1-2", label: "1-2 Years" },
  //   { value: "2-3", label: "2-3 Years" },
  //   { value: "3-4", label: "3-4 Years" },
  //   { value: "4-5", label: "4-5 Years" },
  //   { value: "5-6", label: "5-6 Years" },
  //   { value: "6-7", label: "6-7 Years" },
  //   { value: "7-8", label: "7-8 Years" },
  //   { value: "8-9", label: "8-9 Years" },
  //   { value: "9-10", label: "9-10 Years" },
  //   { value: "10+", label: "10+ Years" },
  // ];

  const handleStartDateChange = (date) => {
    setStartDate(date);

    // Automatically set the closing date with an interval of 10 days
    const newEndDate = date ? addDays(date, 10) : null;
    setEndDate(newEndDate);
  };

  const handleSkillChange = (selectedOption) => {
    setSkillId(selectedOption);
    setSelectedSkills(selectedOption);

    console.log("sskilss", selectedSkills);
  };

  const insertNewSkill = (event) => {
    if (event.key == "Enter") {
      let obj = {
        label: event.target.value,
        value: Math.random(),
      };
      setJobSkills([...jobSkills, obj]);
    }
  };

  const openingInit = () => {
    var req = {
      functionName: "job_opening_init",
      site_id: localStorage.getItem("siteId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        setJobTypes(response.job_type);
        setStatusTypes(response.status);
        setPriorityTypes(response.priority);
        const transformedOptions = response.skills.map((skill, index) => ({
          value: index + 1,
          label: skill.skill_name,
        }));
        setJobSkills(transformedOptions);
      } else {
        toast.warn("Wrong username or password", { containerId: "D" });
        return false;
      }
    });
  };

  const openingHistory = () => {
    var req = {
      functionName: "job_opening_Listing_byUser",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        setOpenings(response.skill);
      } else {
        console.log("error in api");
        return false;
      }
    });
  };

  // const resetForm = () => {
  //   setStatus("");
  //   setPriority("");
  //   setJobType("");
  //   setSummary("");
  //   setDescription("");
  //   setPositionsOpen("");
  //   setExperience("");
  //   setStartDate(new Date());
  //   setEndDate(new Date());
  //   setSalary("");
  //   setLocation("");
  //   setSelectedSkills([]);
  //   setJobSkills([]);
  // };

  const createOpening = (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }

    if (summary === "") {
      toast.warn("Please enter posting summary", { containerId: "D" });
      return false;
    } else if (description === "") {
      toast.warn("Please enter posting description", { containerId: "D" });
      return false;
    } else if (!endDate) {
      toast.warn("Please enter closing date", { containerId: "D" });
      return false;
    } else if (positionsOpen === "") {
      toast.warn("Please enter number of open positions", { containerId: "D" });
      return false;
    } else if (status === "") {
      toast.warn("Please select a status", { containerId: "D" });
      return false;
    } else if (priority === "") {
      toast.warn("Please select a priority", { containerId: "D" });
      return false;
    } else if (experience === "") {
      toast.warn("Please select experience", { containerId: "D" });
      return false;
    } else if (jobType === "") {
      toast.warn("Please select job type", { containerId: "D" });
      return false;
    } else if (location === "") {
      toast.warn("Please enter posting location", { containerId: "D" });
      return false;
    } else if (startDate >= endDate) {
      toast.warn("Open Date must be earlier than Target Date.", {
        containerId: "D",
      });
      return false;
    } else if (selectedSkills.length == 0) {
      toast.warn("Please select required skill set", {
        containerId: "D",
      });
      return false;
    }
    let formattedStartDate;
    let formattedEndDate;
    if (endDate) {
      formattedStartDate = startDate.toISOString().split("T")[0];
      formattedEndDate = endDate.toISOString().split("T")[0];
    }
    const skillLabels = selectedSkills
      .filter((skill) => skill && skill.label)
      .map((skill) => skill.label);

    setIsSubmitting(true);

    var req = {
      functionName: "job_opening_save",
      summary: summary,
      description: description,
      no_of_position: positionsOpen,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      status: status,
      priority: priority,
      experiance: experience,
      job_type: jobType,
      location: location,
      salary: salary,
      skill: skillLabels,
      created_by: localStorage.getItem("userId"),
      site_id: localStorage.getItem("siteId"),
      recruiters: recruiters.map((data) => data.value),
      reportingManagers: users.map((data) => data.value),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        setIsSubmitting(false);
        toast.success("Job Opening created succesfully.", { containerId: "D" });
        // openingHistory();
        console.log("insertId", response.skill.insertId);
        // resetForm();
        setTimeout(() => {
          navigate(`/process`, {
            state: {
              props: response.skill.insertId,
            },
          });
        }, 2000);
      } else {
        setIsSubmitting(false);
        toast.warn("Error creating job opening", { containerId: "D" });
        return false;
      }
    });
  };

  const handlePositionsChange = (e) => {
    const inputValue = e.target.value;

    // Use a regular expression to allow only positive integers
    if (/^[1-9]\d*$/.test(inputValue) || inputValue === "") {
      setPositionsOpen(inputValue);
    }
  };

  const viewHistory = () => {
    const yourProp = openings;
    navigate(`/jobHistory`, {
      state: {
        props: yourProp,
      },
    });
  };

  const goBack = () => {
    navigate(-1);
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  const customStyles = {
    menu: (base) => ({
      ...base,
      top: "auto", // Resetting default positioning
      bottom: "100%", // Positioning the dropdown menu above the select input
      maxHeight: "200px",
    }),
  };
  const getUserList = () => {
    const api = {
      functionName: "userListing",
      site_id: userDetails[0].site_id,
    };
    backendApi(api).then((response) => {
      if (response.success === "1") {
        const recruiters = response.dataSet
          .filter((obj) => obj.roleId === 1 || obj.roleId === 5)
          .map((m) => ({
            ...m,
            label: `${m.first_name} ${m.last_name}`,
            value: m.id,
          }));
        setRecruitersList(recruiters);
        setUserList(
          response.dataSet.map((m) => ({
            ...m,
            label: `${m.first_name} ${m.last_name}`,
            value: m.id,
          }))
        );
        // getRequirementOpenings();
      }
    });
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  };
  const [selectedFile1, setSelectedFile1] = useState(null);
  const handleFileChange1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile1(file);
    } else {
      setSelectedFile1(null);
    }
  };

  const [selectedFile3, setSelectedFile3] = useState(null);
  const handleFileChange3 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile3(file);
    } else {
      setSelectedFile3(null);
    }
  };
  const [selectedFile4, setSelectedFile4] = useState(null);
  const handleFileChange4 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile4(file);
    } else {
      setSelectedFile4(null);
    }
  };


  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"D"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Blacklist"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <>

            <>
              <div className="card main-card">
                <div className="card-body">

                  <div className="row  mb-0 mb-md-3">
                    <div class="form-group col-md-6 mb-md-0 mb-3">
                      <label htmlFor="" className="form-label">
                        Reason :{" "}
                        <span className="text-danger">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Reason"
                        value={summary}
                        onChange={(e) => setSummary(e.target.value)}
                      />
                    </div>
                    <div class="form-group col-md-6 mb-md-0 mb-3">
                      <label htmlFor="" className="form-label">
                        Details:{" "}
                        <span className="text-danger">*</span>{" "}
                      </label>
                      <textarea
                        className="form-control textarea"
                        placeholder="Enter Details"
                        value={description}
                        rows="1"
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="row  mb-0 mb-md-3">
                    <div className="form-group col-md-6 mb-md-0 mb-3">
                      <label htmlFor="" className="form-label">
                        Duration Start : <span className="text-danger">*</span>{" "}
                      </label>
                      <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        className="form-control w-100"
                        dateFormat="dd/MM/yyyy"
                        showYearDropdown
                        minDate={new Date()}
                        showMonthDropdown
                        placeholderText="Select date "
                      />
                    </div>
                    <div className="form-group col-md-6 mb-md-0 mb-3">
                      <label htmlFor="" className="form-label">
                        {" "}
                        Duration end : <span className="text-danger">
                          *
                        </span>{" "}
                      </label>
                      <DatePicker
                        selected={endDate}
                        minDate={new Date()}
                        onChange={(date) => setEndDate(date)}
                        className="form-control w-100"
                        dateFormat="dd/MM/yyyy"
                        showYearDropdown
                        showMonthDropdown
                        placeholderText="Select date "
                      />
                    </div>
                  </div>
                  <div className="row  mb-0 mb-md-3">
                    <div className="form-group col-md-6 mb-md-0 mb-3">
                      <label htmlFor="" className="form-label">
                        Status :{" "}
                        <span className="text-danger ">*</span>{" "}
                      </label>
                      <select
                        className="form-control"
                        onChange={(e) => setStatus(e.target.value)}
                        value={status}
                      >
                        <option value="">Select a Status</option>
                        <option value="Open">Open</option>
                        <option value="Pending">Pending</option>
                        <option value="Closed">Closed</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6 mb-md-0 mb-3">
                      <label htmlFor="" className="form-label">
                        Notes:{" "}
                        <span className="text-danger">*</span>{" "}
                      </label>
                      <textarea
                        className="form-control textarea"
                        placeholder="Enter Notes"
                        rows="1"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6 mb-4 d-flex flex-coulmn">
                          <div className="form-group mb-0">
                            <label className="form-label">
                              Attach 1
                            </label>
                            <span className="browse-files mx-2">
                              <input
                                type="file"
                                onChange={handleFileChange}
                              />
                            </span>
                            {selectedFile && (
                              <span className="d-flex flex-column my-2">
                                <img
                                  src={URL.createObjectURL(selectedFile)}
                                  width="200"
                                  alt="profile-img"
                                  className="img-fluid img-upload"
                                />
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 mb-4">
                          <div className="form-group mb-0">
                            <label className="form-label">
                              Attach 2
                            </label>
                            <span className="browse-files mx-2">
                              <input
                                type="file"
                                onChange={handleFileChange1}
                              />
                            </span>
                            {selectedFile1 && (
                              <span className="d-flex flex-column my-2">
                                <img
                                  src={URL.createObjectURL(selectedFile1)}
                                  width="200"
                                  alt="profile-img"
                                  className="img-fluid img-upload"
                                />
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6 mb-4 d-flex flex-coulmn">
                          <div className="form-group mb-0">
                            <label className="form-label">
                              Attach 3
                            </label>
                            <span className="browse-files mx-2">
                              <input
                                type="file"
                                onChange={handleFileChange3}
                              />
                            </span>
                            {selectedFile3 && (
                              <span className="d-flex flex-column my-2">
                                <img
                                  src={URL.createObjectURL(selectedFile3)}
                                  width="200"
                                  alt="profile-img"
                                  className="img-fluid img-upload"
                                />
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 mb-4">
                          <div className="form-group mb-0">
                            <label className="form-label">
                              Attach 4
                            </label>
                            <span className="browse-files mx-2">
                              <input
                                type="file"
                                onChange={handleFileChange4}
                              />
                            </span>
                            {selectedFile4 && (
                              <span className="d-flex flex-column my-2">
                                <img
                                  src={URL.createObjectURL(selectedFile4)}
                                  width="200"
                                  alt="profile-img"
                                  className="img-fluid img-upload"
                                />
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div className="col-md-12 d-flex flex-wrap align-items-center justify-content-end gap-3">
                    <button
                      type="button"
                      className="btn btn-btn1 btn-btn"
                      onClick={createOpening}
                      disabled={isSubmitting}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-btn2 btn-btn"
                      onClick={goBack}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </>

          </>
        </div>
      </div>
    </>
  );
}
